import React from 'react';
import styled from 'styled-components';
import { vars } from '../../../theme';
import { Drawer } from 'vaul';
import { Z_INDEX } from '../../../styles/variables';
import DrawerHeader from './HBColorPickerDrawerHeader';

interface ColorPickerDrawerProps {
    isOpen: boolean;
    onSave: () => void;
    onClose: () => void;
    className?: string;
    parent?: HTMLElement;
    title?: string;
    testId: string;
    children: React.ReactNode;
}

const HBColorPickerDrawer = ({
    isOpen,
    onSave,
    onClose,
    className,
    parent,
    title,
    testId,
    children
}: ColorPickerDrawerProps) => (
    <Drawer.Root open={isOpen} dismissible={false}>
        <Drawer.Portal container={parent}>
            <DrawerContentContainer
                className={className}
                onEscapeKeyDown={onClose}
                onPointerDownOutside={onClose}
            >
                <DrawerHeader
                    onSave={onSave}
                    onClose={onClose}
                    title={title}
                    testId={testId}
                />
                <Content>{children}</Content>
            </DrawerContentContainer>
        </Drawer.Portal>
    </Drawer.Root>
);

export default HBColorPickerDrawer;

// -------------------------------- Styles -------------------------------- //
const DrawerContentContainer = styled(Drawer.Content)`
    position: fixed;
    bottom: 0;
    inset-inline: 0;
    z-index: ${Z_INDEX.POPOVER};
    max-height: 90%;
    background: ${vars.colors.surface.container};
    border-radius: 0 ${vars.radius.md} 0 ${vars.radius.md};
`;

const Content = styled.section`
    padding: 20px 16px 40px;
    background: ${vars.colors.surface.container};
    position: relative;
`;
